import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'

interface UseRegressGovernmentAllocationEntryProps {
  id?: string
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

const useRegressGovernmentAllocationEntry = ({ id, onSuccess, onError }: UseRegressGovernmentAllocationEntryProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['regressGovernmentAllocationEntry'],
    mutationFn: async () => {
      await privateAxios.put(`/billing/government_allocation_entries/${id}/regress`)
    },
    onSuccess,
    onError,
  })
}

export default useRegressGovernmentAllocationEntry
